
import {defineComponent} from 'vue';

export default defineComponent({
  props: {
    share: {
      type: Boolean,
      required: false,
      default: true,
    },
    title: {
      type: String,
      required: false,
      default: 'Deel dit bericht',
    },
  },
  data() {
    return {
      currentUrl: '',
      shareModal: false,
    };
  },
  mounted() {
    this.currentUrl = location.origin + this.$nuxt.$route.path;
  },
  methods: {
    open() {
      this.shareModal = true;
    },
    close() {
      this.shareModal = false;
    },
  },
});
